import React, { Component } from 'react';
import { LoadingSpinner } from 'pp-react-v5';
import withTheme from '../../setup/componentsV3/withTheme';

class Spinner extends Component {
  render() {
    return <LoadingSpinner size="lg" />;
  }
}

export default withTheme(Spinner);
